/**
 * 数据传输安全改造：AES 加解密工具
 * 与后端 org.jeecg.common.util.AesUtil 对应：
 * 算法 AES/CBC/PKCS7(=PKCS5)Padding，密文格式 Base64(IV) + ':' + Base64(密文)
 */
import CryptoJS from 'crypto-js';

/**
 * AES 加密
 * @param {string} plaintext 明文
 * @param {string} key 密钥（UTF-8 字符串）
 * @returns {string} Base64(IV):Base64(密文)
 */
export function aesEncrypt(plaintext, key) {
  const keyBytes = CryptoJS.enc.Utf8.parse(key);
  // 每次请求生成随机 IV，放在密文前缀传输
  const iv = CryptoJS.lib.WordArray.random(16);
  const encrypted = CryptoJS.AES.encrypt(plaintext, keyBytes, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return CryptoJS.enc.Base64.stringify(iv) + ':' + encrypted.toString();
}

/**
 * AES 解密
 * @param {string} ciphertext Base64(IV):Base64(密文)
 * @param {string} key 密钥（UTF-8 字符串）
 * @returns {string} 明文
 */
export function aesDecrypt(ciphertext, key) {
  const keyBytes = CryptoJS.enc.Utf8.parse(key);
  const parts = ciphertext.split(':');
  const iv = CryptoJS.enc.Base64.parse(parts[0]);
  const encrypted = parts[1];
  const decrypted = CryptoJS.AES.decrypt(encrypted, keyBytes, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}
